import React,{useState,useRef,useEffect} from 'react';
import './popup.css' 
const Popup = (props) =>{   
   const [mousePos, setMousePos] = useState({});
   let classes="popup-content shadow height-auto"; 
   if(props.customClasses!=undefined && props.customClasses!="")
   {
      classes=props.customClasses
   }
   // useEffect(() => {
   //    const handleMouseMove = (event) => {
   //      setMousePos({ x: event.clientX, y: event.clientY });
   //    };
  
   //    window.addEventListener('mousemove', handleMouseMove); 
   //    return () => {
   //      window.removeEventListener(
   //        'mousemove',
   //        handleMouseMove
   //      );
   //    };
   //  }, []);
const dragStart = (ev) => { 
   //ev.dataTransfer.setData("text", ev.target.id);
 };

 const dragOver = (ev) => {
   //ev.preventDefault();
 };
 const drop = (ev) => { 
   // ev.preventDefault();   
   // var moveDiv=document.getElementById('custompopup')
   // if( moveDiv)
   // {
   //    var x = ev.clientX,
   //    y = ev.clientY; 
   //    moveDiv.style.position="absolute"
      
   //    moveDiv.style.top= (y) + 'px'; 
   //    if(x<1)
   //    {
   //       moveDiv.style.left= (x-900) + 'px'; 
   //    }
   //    else
   //    {
   //       moveDiv.style.left= (x) + 'px'; 
   //    }
      
      

   // }
   
 };
 


return (

<div id="myModal" className={"popup"} style={props.open===true?{display: "block"}:{display: "none"}}  >  
   <div    id="custompopup"   className={classes}  >
   
      <span style={{cursor:"move"}} ><h3>{props.title} <span className="close" title="Click here to close" onClick={()=>props.onClose()} >×</span></h3></span>
      
       { <div   className="popup-line" />}
       { props.children} 
      {/* Mouse Position X:-{mousePos.x}, Y:- {mousePos.y} */}
      </div>
      
   </div>


   
   )

}

export default Popup;